import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { BankDetail } from '../components/registration/bank-details/bankDetails';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class BankDetailService  extends BaseService{

  constructor(private http: HttpClient, tokenService: TokenService) {
    super(tokenService);
  }

    getBankDetails(id: string): Observable<any> {
        return this.http.get<any>(environment.apiUrl + 'BankDetails/GetByFarmerId?FarmerID=' + id)
    }
    getAllBankNames(): Observable<any> {
        return this.http.get<any>(environment.apiUrl + 'BankDetails/GetAllBankNames')
    }
    getFarmerIdByMobileNo(id: string): Observable<any> {
        return this.http.get<any>(environment.apiUrl + 'PersonalDetails/GetFarmerIDByMobileNo?MobileNumber=' + id)
    }
    postBankDetails(data: any): Observable<any> {
        return this.http.post<any>(environment.apiUrl + 'BankDetails/Insert', data)
    }
    deleteBankDetails(data: any): Observable<any> {
        return this.http.post<any>(environment.apiUrl + 'BankDetails/Delete', data)
    }

    uploadFile(data, mobile, uploadType){
      return this.http.post(`${environment.apiUrl}File/Upload?MobileNo=${mobile}&UploadType=${uploadType}`, data,
      // {
      //   headers: {
      //     'Content-Type': 'multipart/form-data',
      //   },
      // }
      )
    }


    bankDetailsInsert_CR(reqBody: any): Observable<any> {
      return this.http.post<any>(environment.apiUrl + 'ChangeRequest/BankDetailsInsert_CR', reqBody)
  }

}
